// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xMdWFDaJEq9MU0kxHfll {
    position: relative;
    min-height: 800px;
    margin-bottom: 32px;
}

.xMdWFDaJEq9MU0kxHfll label {
    margin-bottom: 0;
}

.sr9pPX41LbJ9yDahZqgR {
    background-color: #fcfbfc;
    border-left: 1px solid #e5e5e5;
    bottom: 0;
    box-shadow: -3px 0px 8px rgba(0, 0, 0, 0.05);
    overflow-y: auto;
    padding-top: 36px;
    position: absolute;
    right: 0;
    top: 0;
    width: 512px;
}

.xmqP8FOsqy8g9IoQ03MD {
    font-weight: normal;
    width: 100%;
}

.Rb8w7MU9GrmPWbVhNbjQ + .Rb8w7MU9GrmPWbVhNbjQ {
    margin-top: 24px;
}

.qQpUoJHXlzmwN_0Y03vk {
    font-weight: 600;
    margin-bottom: 8px;
}

.bWKRRScXdo2ARmoJQOvG {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    padding: 24px;
}

.bWKRRScXdo2ARmoJQOvG > a {
    margin-right: 16px;
}

.yX5Ye4cVRFf2ohHgGfsQ > textarea {
    border-radius: 3px;
    border: 1px solid #ddd;
    min-height: 96px;
    padding: 8px;
    resize: vertical;
    width: 100%;
}

.uxkhX2gvrlnWvOVzJ64h {
    display: flex;
    justify-content: space-between;
}

.uxkhX2gvrlnWvOVzJ64h > div {
    background-color: white;
    flex: 1;
}

.uxkhX2gvrlnWvOVzJ64h > div:first-child {
    margin-right: 8px;
}

.uxkhX2gvrlnWvOVzJ64h > div:last-child {
    margin-left: 8px;
}

.chBrwye4mCO8L210VgAI {
    font-weight: 600;
    font-size: 16px;
}

.WA9sV2VZif1rdcDp89X5 {
    align-items: center;
    display: flex;
}

.WA9sV2VZif1rdcDp89X5 + .WA9sV2VZif1rdcDp89X5 {
    margin-top: 8px;
}

.xmqP8FOsqy8g9IoQ03MD {
    flex: 1;
}

.jYwIw8jzluvooji5Og8B {
    flex: 1;
}

.jYwIw8jzluvooji5Og8B input,
.jYwIw8jzluvooji5Og8B select {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/waitlist-update/manual-contact/components/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,SAAS;IACT,4CAA4C;IAC5C,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,OAAO;AACX;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,OAAO;AACX;;AAEA;;IAEI,WAAW;AACf","sourcesContent":[".content {\n    position: relative;\n    min-height: 800px;\n    margin-bottom: 32px;\n}\n\n.content label {\n    margin-bottom: 0;\n}\n\n.panel {\n    background-color: #fcfbfc;\n    border-left: 1px solid #e5e5e5;\n    bottom: 0;\n    box-shadow: -3px 0px 8px rgba(0, 0, 0, 0.05);\n    overflow-y: auto;\n    padding-top: 36px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 512px;\n}\n\n.label {\n    font-weight: normal;\n    width: 100%;\n}\n\n.section + .section {\n    margin-top: 24px;\n}\n\n.sectionHeading {\n    font-weight: 600;\n    margin-bottom: 8px;\n}\n\n.responseActions {\n    align-items: center;\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 24px;\n    padding: 24px;\n}\n\n.responseActions > a {\n    margin-right: 16px;\n}\n\n.notes > textarea {\n    border-radius: 3px;\n    border: 1px solid #ddd;\n    min-height: 96px;\n    padding: 8px;\n    resize: vertical;\n    width: 100%;\n}\n\n.results {\n    display: flex;\n    justify-content: space-between;\n}\n\n.results > div {\n    background-color: white;\n    flex: 1;\n}\n\n.results > div:first-child {\n    margin-right: 8px;\n}\n\n.results > div:last-child {\n    margin-left: 8px;\n}\n\n.applicantName {\n    font-weight: 600;\n    font-size: 16px;\n}\n\n.question {\n    align-items: center;\n    display: flex;\n}\n\n.question + .question {\n    margin-top: 8px;\n}\n\n.label {\n    flex: 1;\n}\n\n.field {\n    flex: 1;\n}\n\n.field input,\n.field select {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `xMdWFDaJEq9MU0kxHfll`,
	"panel": `sr9pPX41LbJ9yDahZqgR`,
	"label": `xmqP8FOsqy8g9IoQ03MD`,
	"section": `Rb8w7MU9GrmPWbVhNbjQ`,
	"sectionHeading": `qQpUoJHXlzmwN_0Y03vk`,
	"responseActions": `bWKRRScXdo2ARmoJQOvG`,
	"notes": `yX5Ye4cVRFf2ohHgGfsQ`,
	"results": `uxkhX2gvrlnWvOVzJ64h`,
	"applicantName": `chBrwye4mCO8L210VgAI`,
	"question": `WA9sV2VZif1rdcDp89X5`,
	"field": `jYwIw8jzluvooji5Og8B`
};
export default ___CSS_LOADER_EXPORT___;
